/**
 * Measuring the named-run lists (a filter's matches, early season's open
 * runs) against the room the plates have. Every list wraps rows of one height.
 * One-line lists (an area's exceptions, the header's lifts) must not cut a name.
 */

const top = (el: Element) => (el as HTMLElement).offsetTop

/** How many wrapped lines a list has. */
export const lineCount = (list: HTMLElement) => new Set([...list.children].map(top)).size

/** Whether an item starts past a list's first `lines` lines. */
export function beyond(list: HTMLElement, lines: number, rowHeight: number, item: HTMLElement) {
  return top(item) - top(list.firstElementChild!) >= lines * rowHeight - 2
}

export const overflows = (box: HTMLElement) => box.scrollHeight > box.clientHeight + 1

/** A one-line box whose content runs past its width. */
export const cut = (box: HTMLElement) => box.scrollWidth > box.clientWidth + 1

/**
 * Lines each list may keep so `box` doesn't overflow: the longest list gives
 * up a line at a time, none below one. Leaves the lists at their natural height.
 */
export function trimLines(box: HTMLElement, lists: HTMLElement[], rowHeight: number): number[] {
  const lines = lists.map(lineCount)
  // A list's own border and padding, so a limit cuts exactly between lines.
  const frame = lists.map((list) => {
    const css = getComputedStyle(list)
    return (
      parseFloat(css.paddingTop) + parseFloat(css.paddingBottom) + parseFloat(css.borderTopWidth)
    )
  })
  const apply = () =>
    lists.forEach((list, i) => (list.style.maxHeight = `${lines[i]! * rowHeight + frame[i]!}px`))
  apply()
  for (let guard = 80; overflows(box) && guard > 0; guard--) {
    let k = -1
    lines.forEach((n, i) => {
      if (n > 1 && (k < 0 || n > lines[k]!)) k = i
    })
    if (k < 0) break
    lines[k]!--
    apply()
  }
  for (const list of lists) list.style.maxHeight = ''
  return lines
}
